import { render } from "./FormCheckbox.vue?vue&type=template&id=6310f3e1"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Form/FormCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6310f3e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6310f3e1', __exports__)) {
    console.log('reload')
    api.reload('6310f3e1', __exports__)
  }
  
  module.hot.accept("./FormCheckbox.vue?vue&type=template&id=6310f3e1", () => {
    console.log('re-render')
    api.rerender('6310f3e1', render)
  })

}


export default __exports__